export const AvatarIcon = () => (
  <svg
    width="46"
    height="46"
    viewBox="0 0 46 46"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="46" height="46" rx="23" fill="#DBFDFC" />
    <mask
      id="mask0_6615_307"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="46"
      height="46"
    >
      <rect width="46" height="46" rx="23" fill="#CFD2DE" />
    </mask>
    <g mask="url(#mask0_6615_307)">
      <path
        d="M16.3747 35.4278L9.57872 38.668C9.17991 38.858 8.8215 39.0917 8.48802 39.3464C-4.41464 57.1279 15.8022 63.8891 21.3907 63.8891C26.9379 63.8891 48.9883 60.0859 37.734 39.4125C37.3696 39.1435 36.9743 38.9016 36.5359 38.7108L29.2586 35.5307C28.3183 35.1198 27.7244 34.2799 27.7244 33.3611V30.8654C27.9289 30.6618 28.1627 30.4004 28.4128 30.0916C29.4047 28.8671 30.155 27.5201 30.675 26.107C31.6084 25.8553 32.296 25.1018 32.296 24.2063V21.5423C32.296 20.9564 31.9978 20.4327 31.5345 20.0661V16.2152C31.5345 16.2152 30.675 10.2224 23.1544 10.2224C15.6339 10.2224 14.7744 16.2152 14.7744 16.2152V20.0661C14.3102 20.4327 14.0129 20.9564 14.0129 21.5423V24.2063C14.0129 24.908 14.4349 25.5255 15.0666 25.8823C15.8281 28.7799 17.8221 30.8654 17.8221 30.8654V33.2995C17.8213 34.186 17.266 35.0026 16.3747 35.4278Z"
        fill="url(#paint0_linear_6615_307)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_6615_307"
        x1="22.5738"
        y1="10.2224"
        x2="22.5738"
        y2="63.8891"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00C7AF" />
        <stop offset="0.74609" stopColor="#00C7AF" />
      </linearGradient>
    </defs>
  </svg>
);